import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Switch from 'react-switch';

const Toggle = ({
    className,
    title,
    leftLabel,
    rightLabel,
    checked = false,
    reversed = false,
    disabled = false,
    direction = 'vertical',
    diameter = 24,
    width = 38,
    height = 16,
    onChange = () => {},
}) => {
    return (
        <div className={cx('ds-toggle', direction, className)}>
            {title && <p className="ds-toggle-label my-0">{title}</p>}
            <div className="d-flex align-items-center">
                <div className={cx('ds-toggle--llabel', { inactive: checked }, { active: !checked })}>{leftLabel}</div>
                <div className={cx('ds-toggle--button', { disabled })}>
                    <Switch
                        disabled={disabled}
                        checked={checked}
                        onChange={onChange}
                        handleDiameter={diameter}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        onColor={reversed ? '#c3c7cc' : '#6899d7'}
                        offColor={reversed ? '#6899d7' : '#c3c7cc'}
                        onHandleColor={reversed ? '#969faa' : '#376caf'}
                        offHandleColor={reversed ? '#376caf' : '#ffffff'}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.2)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        className="react-switch"
                        id="material-switch"
                        width={width}
                        height={height}
                    />
                </div>
                <div className={cx('ds-toggle--rlabel', { active: checked }, { inactive: !checked })}>{rightLabel}</div>
            </div>
        </div>
    );
};

Toggle.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    leftLabel: PropTypes.string,
    rightLabel: PropTypes.string,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    reversed: PropTypes.bool,
    width: PropTypes.number,
    height: PropTypes.number,
    diameter: PropTypes.number,
    direction: PropTypes.oneOf(['horizontal', 'vertical']),
    onChange: PropTypes.func,
};

export default Toggle;
